// @flow
import { BlockquoteButton } from "draft-js-buttons"
import Configuration from "../configuration"

export default () => ({ addInlineBlockButton }: Configuration) => {
  addInlineBlockButton(BlockquoteButton)
}
